<template>
  <messenger-qr-code-view-layout
    :channel-title="viewSettings.channel.name"
    :channel-description="viewSettings.channel.description"
    :channel-type="viewSettings.channel.type"
    :content-title="viewSettings.title"
    :content-description="viewSettings.description"
    :button-text="viewSettings.buttonText"
    :scan-qr-text="$t('messengerWidget.scanQrToOpenChat')"
    :contact-data="contactData"
    :qr-code-logo-url="whatsAppOutlinedLogo"
    :show-qr-code="viewSettings.showQrCode"
    open-href-in-new-window
    @back="$emit('back')"
    @resize="$emit('resize', $event)"
  >
    <template v-slot:alert>
      <slot name="alert"></slot>
    </template>

    <template v-slot:not-exists-contact-data>
      <slot name="not-exists-contact-data"></slot>
    </template>
  </messenger-qr-code-view-layout>
</template>

<script setup lang="ts">
import type { MessengerWhatsappViewSettings, QrCodeContactData } from '@widgets/messenger/types'
import { phoneService } from '@widgets/shared/services/phoneService'
import MessengerQrCodeViewLayout from '@widgets/messenger/components/MessengerQrCodeViewLayout.vue'
import { computed } from '@/composition/vue/compositionApi'
import whatsAppOutlinedLogo from '@/assets/images/whatsapp-outlined.svg'

const props = defineProps<{
  viewSettings: MessengerWhatsappViewSettings
}>()

defineEmits<{
  (e: 'back'): void
  (e: 'resize', height: number): void
}>()

const contactData = computed(() => {
  const { suitableNumber } = props.viewSettings
  if (!suitableNumber) {
    return undefined
  }
  const href = suitableNumber ? phoneService.getHrefForWhatsapp(suitableNumber.phone) : ''
  return {
    phoneNumber: suitableNumber,
    href,
  } satisfies QrCodeContactData
})
</script>
